import React from 'react';

export const loadDetailsData = loadDetails => {
  return (
    <div className='load-details__main-data-container'>
      <div className='load-details__load-number'>{loadDetails?.loadNumber}</div>
      <div className='load-details__data-container'>
        <div className='load-details__info-data'>
          <span>Carrier:</span>
          <span>{loadDetails?.carrierName}</span>
        </div>
        <div className='load-details__info-data'>
          <span>MC Number:</span>
          <span>{loadDetails?.mc}</span>
        </div>
        <div className='load-details__info-data'>
          <span>DOT:</span>
          <span>{loadDetails?.dot}</span>
        </div>
        <div className='load-details__info-data'>
          <span>Disp#:</span>
          <span>{loadDetails.carrierEmail}</span>
        </div>
        <div className='load-details__info-data'>
          <span>Driver name:</span>
          <span>
            {loadDetails?.driverName} {loadDetails?.driverEmail}
          </span>
        </div>
        <div className='load-details__info-data'>
          <span>Driver phone:</span>
          <span>{loadDetails?.driverPhone}</span>
        </div>
        <div className='load-details__info-data'>
          <span>Scale Ticket:</span>
          <span>{loadDetails?.scaleTicket ? 'Yes' : loadDetails?.scaleTicket === 'false' ? 'No' : null}</span>
        </div>
      </div>
    </div>
  );
};
